import { useStorage } from '@vueuse/core'
interface User {
  id?: number
  email?: string
  api_token?: string
  tenant_identifier?: string
  api_tokenV2?: string
  tenant_identifierV2?: string
  mid?: number
}
export const useUserStore = defineStore('userStore', () => {
  const toast = useToast()

  const { apiBaseUrl, apiBaseUrlV2 } = useAppConfig()
  const user = ref(useStorage('user', {} as User, localStorage))
  const calendarCategories = ref()
  const hasSupervisor = ref<boolean | null>(null)

  const isLoggedIn = computed(() => !!user.value.api_token)
  const userEmail = computed(() => user.value.email ?? '-')
  const userProfilePicture = computed(() =>
    user?.value?.id
      ? `https:\\/\\/my.1tool.com\\/crm_files\\/users\\/${user.value.id}\\/logo.jpg`
      : 'https:\\/\\/my.1tool.com\\/images\\/standard_picture.jpg'
  )

  async function login(email: string, password: string): Promise<boolean> {
    try {
      const body = JSON.stringify({ email, password, device_name: 'mac' })
      const headers = { 'Content-Type': 'application/json', Accept: 'application/json' }

      const [responseV1, responseV2] = await Promise.all([
        fetch(`${apiBaseUrl}auth/user`, {
          method: 'POST',
          headers,
          body,
          cache: 'no-cache',
          mode: 'cors'
        }),
        fetch(`${apiBaseUrlV2}auth/user`, {
          method: 'POST',
          headers,
          body,
          cache: 'no-cache',
          mode: 'cors'
        })
      ])

      if (!responseV1.ok || !responseV2.ok) {
        return false
      }

      const {
        api_token: apiToken,
        tenant_identifier: tenantIdentifier,
        id
      } = await responseV1.json()
      const { api_token: apiTokenV2, tenant_identifier: tenantIdentifierV2 } =
        await responseV2.json()

      if (!apiToken) {
        return false
      }

      user.value = {
        id,
        email,
        api_token: apiToken,
        tenant_identifier: tenantIdentifier,
        api_tokenV2: apiTokenV2,
        tenant_identifierV2: tenantIdentifierV2
      }
      return true
    } catch {
      toast.add({
        severity: 'error',
        summary: 'Fehler',
        detail: 'Login-Service konnte nicht erreicht werden'
      })
      return false
    }
  }

  async function logout() {
    user.value = {}
    window?.localStorage?.clear()
    await navigateTo('/login')
  }

  return {
    user,
    userEmail,
    userProfilePicture,
    isLoggedIn,
    calendarCategories,
    hasSupervisor,
    login,
    logout
  }
})
// Use HMR for this store
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useUserStore, import.meta.hot))
}
